// extracted by mini-css-extract-plugin
export default {"container":"ez734a2bkyHQbxyyQKgX","answersBox":"U5oSU2OtoyYelfYMjrld"};